import React from "react";
import styled from "styled-components";
import { ResponsiveLayout } from "@bca/ui-library";

import ConditionReportDetails from "./ConditionReportDetails";
import MechanicalReportDetails from "./MechanicalReportDetails";

import VehicleTypes from "../types/vehicleTypes";

import { Report } from "../vehicleDetails/vehicle-details-props.type";

const HalfGreyBackground = styled.div`
  background-image: linear-gradient(transparent 50%, #fafafa 50%);
`;

interface ConditionAndMechanicalReportsProps {
  vehicleType: VehicleTypes;
  conditionReport?: Report;
  mechanicalReport?: Report;
  grade: number;
  conditionSummaries?: ConditionSummaries[];
}

interface ConditionSummaries {
  severityType: string;
  numberOfItems: number;
  reportType: string;
}

const ConditionAndMechanicalReports: React.FunctionComponent<
  ConditionAndMechanicalReportsProps
> = ({
  vehicleType,
  conditionReport,
  mechanicalReport,
  grade,
  conditionSummaries,
}) => {
  if (!(conditionReport?.href || mechanicalReport?.href)) {
    return null;
  }

  return (
    <HalfGreyBackground>
      <ResponsiveLayout
        display="flex"
        flexDirection={{ mobile: "column", tablet: "row", desktop: "row" }}
        flexWrap={{ mobile: "wrap", tablet: "wrap", desktop: "nowrap" }}
        justifyContent="space-between"
      >
        {conditionReport?.href && (
          <ConditionReportDetails
            report={conditionReport}
            grade={grade}
            vehicleType={vehicleType}
          />
        )}
        {mechanicalReport?.href && (
          <MechanicalReportDetails
            report={mechanicalReport}
            conditionSummaries={conditionSummaries}
          />
        )}
      </ResponsiveLayout>
    </HalfGreyBackground>
  );
};

export default ConditionAndMechanicalReports;
